import { Component, OnInit, Inject } from '@angular/core';
import { UnitsService } from 'src/app/services/units.service';
import { VillageService } from 'src/app/services/village.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MangeUnitsComponent } from '../mange-units/mange-units.component';

@Component({
  selector: 'app-addunit',
  templateUrl: './addunit.component.html',
  styleUrls: ['./addunit.component.css']
})
export class AddunitComponent implements OnInit {

  typename:any = "EX. Rental"
  villageName:any = "Village name"
  villageId:any =""
  type_arr:any
  vilage_arr:any
  unitName:any = ""
  unitId:any = ""
  typeId:any = ""
  constructor(private rest : UnitsService ,
    public dialogRef: MatDialogRef<MangeUnitsComponent>,
     private apis : VillageService){}

  ngOnInit(){
    this.getVillage()
    this.gettypes()
  }

  getVillage(){
    this.apis.villageList().subscribe((res :any) => {
      console.log(res)
      this.vilage_arr = res
    })
  }

  gettypes(){
    this.rest.getTypes().subscribe((res :any) => {
      console.log(res)
      this.type_arr = res.children

    })
  }

  chooseType(value:any){
    this.typename = value.name
    this.typeId = value.id
    this.erorrUnittype = false
  }

  chooseVillage(value:any){
    this.villageName = value.name
    this.villageId = value.id
    this.erorrVillage = false

  }

  erorrUnitName = false
  erorrUnitId = false
  erorrUnittype = false
  erorrVillage = false
  addUnit(){
    if(this.unitName == ""){
      this.erorrUnitName = true
    }
    if(this.unitId == ""){
      this.erorrUnitId = true
    }
    if(this.villageId == ""){
      this.erorrVillage = true
    }
    if(this.typeId == ""){
      this.erorrUnittype = true
    }
    if(this.unitName == "" || this.unitId == "" || this.villageId == "" || this.typeId == "" ){
      return
    }else {
      let unit = {
        name : this.unitName,
        village_id :  this.villageId , 
        ext_id : this.unitId,
        unit_type_id : this.typeId
      }
      this.dialogRef.close(unit);
    }
  }

  getUnitName(event:any){
    if(!event.target.value){
      this.erorrUnitName = true
    }else {
      this.erorrUnitName = false
    }
  }
  getUnitId(event:any){
    if(!event.target.value){
      this.erorrUnitId = true
    }else {
      this.erorrUnitId = false
    }
  }
}
